/**
 * A seller from the producer/trending-sellers API (PlatformSaleService.getTrendingSellerList).
 * The API returns 6-slot bands (Seller Listing Algorithm v3.0): pool 1 Pro, pool 2 Premium, pool 3 Basic,
 * ranked by activity score, max 1 seller per primary genre per band.
 */
export interface TrendingSellerModel {
    id: string;
    handle: string;
    name: string;
    avatar: string;
    /** Primary genre, readable ("hip_hop" -> "Hip Hop"); the card's genre badge and the genre filter */
    genre: string;
    followers: number | null;
    likes: number | null;
    plays: number | null;
    isFollowed: boolean;
    /** 1 Pro, 2 Premium, 3 Basic */
    pool: 1 | 2 | 3;
    activityScore: number | null;
    /** Card badges ("Pro", "Premium"); from the API, else from the pool */
    badges: Array<string>;
    /** Seller joined less than 30 days ago */
    isNew: boolean;
    /** "connect": Pro seller with Lead Gen Access, the card shows a Connect button */
    ctaType: string;
}

/** One page of the trending sellers (the Top Sellers page asks for ?offset=&limit=) */
export interface TrendingSellerPage {
    sellers: Array<TrendingSellerModel>;
    offset: number;
    limit: number;
    /** More sellers after this page */
    hasMore: boolean;
}

/** Avatar backgrounds for sellers without a photo (picked by position in the list) */
export const TRENDING_SELLER_GRADIENTS: Array<string> = [
    'linear-gradient(135deg,#5b21b6,#7c3aed)', 'linear-gradient(135deg,#1a1a2e,#3b1a6e)', 'linear-gradient(135deg,#7c2d12,#ea580c)',
    'linear-gradient(135deg,#064e3b,#059669)', 'linear-gradient(135deg,#1e1b4b,#4338ca)', 'linear-gradient(135deg,#78350f,#d97706)',
    'linear-gradient(135deg,#0c4a6e,#0284c7)', 'linear-gradient(135deg,#1c1917,#57534e)',
];
